"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOG_THROTTLE_TIME_MS = exports.MEDICAL_CALCULATOR_DOWNLOADABLE = exports.SHARE_MOB_BASE_URL = exports.APP_STORE_WEB_LINK = exports.PLAY_STORE_WEB_LINK = exports.APP_STORE_LINK = exports.PLAY_STORE_LINK = exports.RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD = exports.SESSION_INTERVAL_TIME = exports.COMMUNITY_ENABLED = exports.GAMIFICATION_ENABLED = exports.SAML_REDIRECTOR_API_CALL = exports.BLOB_FILES_CONTAINER_PARAMS = exports.APP_VERSION_PARAMS = exports.SUPPORTED_LANGUAGES = exports.REDIRECTION_SHALINA_CONTENT = exports.RESEND_TIMER = exports.WEB_URL = exports.SHOW_DEFAULT_EXPERTS = exports.HIDE_FOR_FIRST_RELEASE = exports.HELP_SUPPORT_CONFIG = exports.SOCIAL_MEDIA_LINKS = exports.BLOB_BASE_URL = exports.LOCALIZATION_BACKEND_ENABLED = exports.APP_INSIGHTS_CONNECTION_STRING = exports.SHOW_NOT_AVAILABLE = exports.CACHE_ENABLED = exports.SUBSCRIPTION_KEY = exports.IMAGE_BASE_URL_WITHOUT_SLASH = exports.IMAGE_BASE_URL = exports.BASE_URL_NODE = exports.BASE_URL = exports.initializeConfigJson = void 0;
const axios_1 = __importDefault(require("axios"));
const environment_1 = require("../environment");
let BASE_URL = '';
exports.BASE_URL = BASE_URL;
let BASE_URL_NODE = '';
exports.BASE_URL_NODE = BASE_URL_NODE;
let IMAGE_BASE_URL = '';
exports.IMAGE_BASE_URL = IMAGE_BASE_URL;
let IMAGE_BASE_URL_WITHOUT_SLASH = '';
exports.IMAGE_BASE_URL_WITHOUT_SLASH = IMAGE_BASE_URL_WITHOUT_SLASH;
let SUBSCRIPTION_KEY = '';
exports.SUBSCRIPTION_KEY = SUBSCRIPTION_KEY;
let CACHE_ENABLED = false;
exports.CACHE_ENABLED = CACHE_ENABLED;
let SHOW_NOT_AVAILABLE = false;
exports.SHOW_NOT_AVAILABLE = SHOW_NOT_AVAILABLE;
let APP_INSIGHTS_CONNECTION_STRING = '';
exports.APP_INSIGHTS_CONNECTION_STRING = APP_INSIGHTS_CONNECTION_STRING;
let LOCALIZATION_BACKEND_ENABLED = false;
exports.LOCALIZATION_BACKEND_ENABLED = LOCALIZATION_BACKEND_ENABLED;
let BLOB_BASE_URL = '';
exports.BLOB_BASE_URL = BLOB_BASE_URL;
let HELP_SUPPORT_CONFIG = {
    WHATSAPP_NUMBER: '',
    EMAIL_ID: '',
    TEXT_MESSAGE: ''
};
exports.HELP_SUPPORT_CONFIG = HELP_SUPPORT_CONFIG;
let WEB_URL = '';
exports.WEB_URL = WEB_URL;
let SAML_REDIRECTOR_API_CALL = false;
exports.SAML_REDIRECTOR_API_CALL = SAML_REDIRECTOR_API_CALL;
let REDIRECTION_SHALINA_CONTENT = false;
exports.REDIRECTION_SHALINA_CONTENT = REDIRECTION_SHALINA_CONTENT;
let APP_VERSION_PARAMS = '';
exports.APP_VERSION_PARAMS = APP_VERSION_PARAMS;
let BLOB_FILES_CONTAINER_PARAMS = '';
exports.BLOB_FILES_CONTAINER_PARAMS = BLOB_FILES_CONTAINER_PARAMS;
let GAMIFICATION_ENABLED = false;
exports.GAMIFICATION_ENABLED = GAMIFICATION_ENABLED;
let COMMUNITY_ENABLED = false;
exports.COMMUNITY_ENABLED = COMMUNITY_ENABLED;
let SESSION_INTERVAL_TIME = 300000; // 5 mins
exports.SESSION_INTERVAL_TIME = SESSION_INTERVAL_TIME;
let configJson = {};
let RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD = false;
exports.RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD = RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD;
let SUPPORTED_LANGUAGES = [];
exports.SUPPORTED_LANGUAGES = SUPPORTED_LANGUAGES;
const MINUTES_IN_MILISECONDS = 60000;
let MEDICAL_CALCULATOR_DOWNLOADABLE = false;
exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE;
let LOG_THROTTLE_TIME_MS = 5000;
exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS;
const initializeConfigJson = (url, urlParams) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield axios_1.default.get(`${url}/config/config.json${urlParams}`);
    configJson = (response === null || response === void 0 ? void 0 : response.data) || {};
    exports.SAML_REDIRECTOR_API_CALL = SAML_REDIRECTOR_API_CALL = configJson === null || configJson === void 0 ? void 0 : configJson.isSAML;
    exports.GAMIFICATION_ENABLED = GAMIFICATION_ENABLED = configJson === null || configJson === void 0 ? void 0 : configJson.isGamificationEnabled;
    exports.COMMUNITY_ENABLED = COMMUNITY_ENABLED = configJson === null || configJson === void 0 ? void 0 : configJson.isCommunityEnabled;
    exports.RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD = RESTRICT_REGISTRATION_REFERRAL_CODE_FIELD = configJson === null || configJson === void 0 ? void 0 : configJson.isRegistrationRestricted;
    exports.SUPPORTED_LANGUAGES = SUPPORTED_LANGUAGES = configJson === null || configJson === void 0 ? void 0 : configJson.supportedLanguages;
    if (configJson === null || configJson === void 0 ? void 0 : configJson.sessionIntervalTime) {
        exports.SESSION_INTERVAL_TIME = SESSION_INTERVAL_TIME = (configJson === null || configJson === void 0 ? void 0 : configJson.sessionIntervalTime) * MINUTES_IN_MILISECONDS;
    }
    if (configJson === null || configJson === void 0 ? void 0 : configJson.isMedicalCalculatorDownloadable) {
        exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE = configJson === null || configJson === void 0 ? void 0 : configJson.isMedicalCalculatorDownloadable;
    }
    if (configJson === null || configJson === void 0 ? void 0 : configJson.isMedicalCalculatorDownloadable) {
        exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS = configJson === null || configJson === void 0 ? void 0 : configJson.logThrottleInMilliseconds;
    }
});
exports.initializeConfigJson = initializeConfigJson;
if (environment_1.currentEnvironment === (environment_1.Environment === null || environment_1.Environment === void 0 ? void 0 : environment_1.Environment.DEV)) {
    // Drupal API base url
    exports.BASE_URL = BASE_URL = "https://shalina-drupal-web-app.azurewebsites.net/";
    // Node API base url
    exports.BASE_URL_NODE = BASE_URL_NODE = "https://shalina-node-web-app.azurewebsites.net/";
    exports.IMAGE_BASE_URL = IMAGE_BASE_URL =
        'https://shalina-drupal-web-app.azurewebsites.net/';
    exports.IMAGE_BASE_URL_WITHOUT_SLASH = IMAGE_BASE_URL_WITHOUT_SLASH =
        'https://shalina-drupal-web-app.azurewebsites.net';
    exports.SUBSCRIPTION_KEY = SUBSCRIPTION_KEY = "8a6b9c7d759542bcb5c9737bad052cb9";
    exports.APP_INSIGHTS_CONNECTION_STRING = APP_INSIGHTS_CONNECTION_STRING = "InstrumentationKey=1368c142-a49a-40ae-a958-38dc44e7df6e;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/";
    // Cache flag
    exports.CACHE_ENABLED = CACHE_ENABLED = true;
    exports.SHOW_NOT_AVAILABLE = SHOW_NOT_AVAILABLE = true;
    //Localization
    exports.LOCALIZATION_BACKEND_ENABLED = LOCALIZATION_BACKEND_ENABLED = false;
    exports.BLOB_BASE_URL = BLOB_BASE_URL = "https://shalinadevstorageaccount.blob.core.windows.net";
    exports.BLOB_FILES_CONTAINER_PARAMS = BLOB_FILES_CONTAINER_PARAMS = '?sv=2022-11-02&ss=b&srt=sco&sp=rlitf&se=2200-04-16T21:36:05Z&st=2024-04-16T13:36:05Z&spr=https,http&sig=fUcJDo220LLqUo71sTeaxFY5JZiye6a6ze6XnuiPNj4%3D';
    exports.HELP_SUPPORT_CONFIG = HELP_SUPPORT_CONFIG = {
        WHATSAPP_NUMBER: '918097032750',
        EMAIL_ID: 'devesh.mishra@extentia.com',
        TEXT_MESSAGE: 'Hi'
    };
    exports.WEB_URL = WEB_URL = 'https://white-ocean-01b767903.4.azurestaticapps.net/',
        exports.REDIRECTION_SHALINA_CONTENT = REDIRECTION_SHALINA_CONTENT = false;
    exports.APP_VERSION_PARAMS = APP_VERSION_PARAMS = '/config/config.json?sp=r&st=2024-04-10T11:50:09Z&se=2200-04-10T19:50:09Z&sv=2022-11-02&sr=c&sig=xO8duxaRUKWl5UPvV7mZwBb10n5uhnCumFEkMjMrLzU%3D';
    exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE = false;
    exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS = 5000;
}
else if (environment_1.currentEnvironment === (environment_1.Environment === null || environment_1.Environment === void 0 ? void 0 : environment_1.Environment.QA)) {
    exports.BASE_URL = BASE_URL = "https://shalina-qa-drupal-web-app.azurewebsites.net/";
    exports.BASE_URL_NODE = BASE_URL_NODE = "https://shalina-qa-node-web-app.azurewebsites.net/";
    exports.IMAGE_BASE_URL = IMAGE_BASE_URL =
        'https://shalina-qa-drupal-web-app.azurewebsites.net/';
    exports.IMAGE_BASE_URL_WITHOUT_SLASH = IMAGE_BASE_URL_WITHOUT_SLASH =
        'https://shalina-qa-drupal-web-app.azurewebsites.net';
    exports.SUBSCRIPTION_KEY = SUBSCRIPTION_KEY = "8a6b9c7d759542bcb5c9737bad052cb9";
    exports.CACHE_ENABLED = CACHE_ENABLED = true;
    exports.SHOW_NOT_AVAILABLE = SHOW_NOT_AVAILABLE = false;
    exports.APP_INSIGHTS_CONNECTION_STRING = APP_INSIGHTS_CONNECTION_STRING = "InstrumentationKey=1368c142-a49a-40ae-a958-38dc44e7df6e;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/";
    exports.LOCALIZATION_BACKEND_ENABLED = LOCALIZATION_BACKEND_ENABLED = true;
    exports.BLOB_BASE_URL = BLOB_BASE_URL = "https://shalinadevstorageaccount.blob.core.windows.net";
    exports.BLOB_FILES_CONTAINER_PARAMS = BLOB_FILES_CONTAINER_PARAMS = '?sv=2022-11-02&ss=b&srt=sco&sp=rlitf&se=2200-04-16T21:36:05Z&st=2024-04-16T13:36:05Z&spr=https,http&sig=fUcJDo220LLqUo71sTeaxFY5JZiye6a6ze6XnuiPNj4%3D';
    exports.HELP_SUPPORT_CONFIG = HELP_SUPPORT_CONFIG = {
        WHATSAPP_NUMBER: '918097032750',
        EMAIL_ID: 'devesh.mishra@extentia.com',
        TEXT_MESSAGE: 'Hi'
    };
    exports.WEB_URL = WEB_URL = 'https://happy-plant-0b4327603.4.azurestaticapps.net/';
    exports.REDIRECTION_SHALINA_CONTENT = REDIRECTION_SHALINA_CONTENT = false;
    exports.APP_VERSION_PARAMS = APP_VERSION_PARAMS = '/config/config.json?sp=r&st=2024-04-10T11:50:09Z&se=2200-04-10T19:50:09Z&sv=2022-11-02&sr=c&sig=xO8duxaRUKWl5UPvV7mZwBb10n5uhnCumFEkMjMrLzU%3D';
    exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE = true;
    exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS = 5000;
}
else if (environment_1.currentEnvironment === (environment_1.Environment === null || environment_1.Environment === void 0 ? void 0 : environment_1.Environment.PREPROD)) {
    exports.BASE_URL = BASE_URL = "https://shalina-pre-prod-drupal-web-app.azurewebsites.net/";
    exports.BASE_URL_NODE = BASE_URL_NODE = "https://shalina-pre-prod-node-web-app.azurewebsites.net/";
    exports.IMAGE_BASE_URL = IMAGE_BASE_URL =
        'https://cmspreprod.shalinamedspace.com/';
    exports.IMAGE_BASE_URL_WITHOUT_SLASH = IMAGE_BASE_URL_WITHOUT_SLASH =
        'https://cmspreprod.shalinamedspace.com';
    exports.SUBSCRIPTION_KEY = SUBSCRIPTION_KEY = "8a6b9c7d759542bcb5c9737bad052cb9";
    exports.CACHE_ENABLED = CACHE_ENABLED = true;
    exports.SHOW_NOT_AVAILABLE = SHOW_NOT_AVAILABLE = false;
    exports.APP_INSIGHTS_CONNECTION_STRING = APP_INSIGHTS_CONNECTION_STRING = "InstrumentationKey=b54b2022-a1fc-4af3-9f8c-517f6891d35b;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/";
    exports.LOCALIZATION_BACKEND_ENABLED = LOCALIZATION_BACKEND_ENABLED = true;
    exports.BLOB_BASE_URL = BLOB_BASE_URL = "https://shalinapreprodstorage.blob.core.windows.net";
    exports.BLOB_FILES_CONTAINER_PARAMS = BLOB_FILES_CONTAINER_PARAMS = '?sv=2022-11-02&ss=bfqt&srt=sco&sp=rlitfx&se=2200-04-16T21:34:13Z&st=2024-04-16T13:34:13Z&spr=https,http&sig=n3%2FBZqCGqVL3Y9bOib1BpWciKFTVi7wN6RP%2FiLDi0dI%3D';
    exports.HELP_SUPPORT_CONFIG = HELP_SUPPORT_CONFIG = {
        WHATSAPP_NUMBER: '917506050288',
        EMAIL_ID: 'support@shalinamedspace.com',
        TEXT_MESSAGE: 'Hi'
    };
    exports.WEB_URL = WEB_URL = 'https://preprod.shalinamedspace.com/';
    exports.REDIRECTION_SHALINA_CONTENT = REDIRECTION_SHALINA_CONTENT = true;
    exports.APP_VERSION_PARAMS = APP_VERSION_PARAMS = '/config/config.json?sp=r&st=2024-04-10T11:53:45Z&se=2200-04-10T19:53:45Z&sv=2022-11-02&sr=c&sig=uynJWa0YtkIzVERTwRMbsoweOzthIlmA0QN5rgXpHhc%3D';
    exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE = false;
    exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS = 5000;
}
else if (environment_1.currentEnvironment === (environment_1.Environment === null || environment_1.Environment === void 0 ? void 0 : environment_1.Environment.PRODUCTION)) {
    exports.BASE_URL = BASE_URL = "https://cms.shalinamedspace.com/";
    exports.BASE_URL_NODE = BASE_URL_NODE = "https://api.shalinamedspace.com/";
    exports.IMAGE_BASE_URL = IMAGE_BASE_URL =
        'https://cms.shalinamedspace.com/';
    exports.IMAGE_BASE_URL_WITHOUT_SLASH = IMAGE_BASE_URL_WITHOUT_SLASH =
        'https://cms.shalinamedspace.com';
    exports.SUBSCRIPTION_KEY = SUBSCRIPTION_KEY = "8a6b9c7d759542bcb5c9737bad052cb9";
    exports.CACHE_ENABLED = CACHE_ENABLED = true;
    exports.SHOW_NOT_AVAILABLE = SHOW_NOT_AVAILABLE = false;
    exports.APP_INSIGHTS_CONNECTION_STRING = APP_INSIGHTS_CONNECTION_STRING = "InstrumentationKey=d96f4d9a-498d-4061-b068-0a6283e4cbc7;IngestionEndpoint=https://southafricanorth-1.in.applicationinsights.azure.com/;LiveEndpoint=https://southafricanorth.livediagnostics.monitor.azure.com/";
    exports.LOCALIZATION_BACKEND_ENABLED = LOCALIZATION_BACKEND_ENABLED = true;
    exports.BLOB_BASE_URL = BLOB_BASE_URL = "https://shalinastorageprodCDN.azureedge.net";
    exports.BLOB_FILES_CONTAINER_PARAMS = BLOB_FILES_CONTAINER_PARAMS = '?sv=2022-11-02&ss=b&srt=sco&sp=rlitfx&se=2200-04-16T21:58:46Z&st=2024-04-16T13:58:46Z&spr=https,http&sig=RR8CGaOgjrKFpnA%2FCsTbnun5q3LaCXzY7xAtiOM0XpQ%3D';
    exports.HELP_SUPPORT_CONFIG = HELP_SUPPORT_CONFIG = {
        WHATSAPP_NUMBER: '917506050288',
        EMAIL_ID: 'support@shalinamedspace.com',
        TEXT_MESSAGE: 'Hi'
    };
    exports.WEB_URL = WEB_URL = 'https://www.shalinamedspace.com/';
    exports.REDIRECTION_SHALINA_CONTENT = REDIRECTION_SHALINA_CONTENT = true;
    exports.SAML_REDIRECTOR_API_CALL = SAML_REDIRECTOR_API_CALL = true;
    exports.APP_VERSION_PARAMS = APP_VERSION_PARAMS = '/config/config.json?sp=r&st=2024-04-10T12:06:25Z&se=2200-04-10T20:06:25Z&sv=2022-11-02&sr=c&sig=B266L8SsOtvUDtfHFWKsiJAyArToSzsthShocOKsRl0%3D';
    exports.MEDICAL_CALCULATOR_DOWNLOADABLE = MEDICAL_CALCULATOR_DOWNLOADABLE = false;
    exports.LOG_THROTTLE_TIME_MS = LOG_THROTTLE_TIME_MS = 5000;
}
const SOCIAL_MEDIA_LINKS = {
    FACEBOOK: 'https://www.facebook.com/shalinahealth',
    INSTAGRAM: 'https://www.instagram.com/shalina_healthcare/',
    LINKEDIN: 'https://www.linkedin.com/company/1130868/admin/feed/posts/',
    YOUTUBE: 'https://www.youtube.com/@shalinahealthcare5426',
    TWITTER: 'https://twitter.com/ShalinaHealthc1'
};
exports.SOCIAL_MEDIA_LINKS = SOCIAL_MEDIA_LINKS;
const HIDE_FOR_FIRST_RELEASE = false;
exports.HIDE_FOR_FIRST_RELEASE = HIDE_FOR_FIRST_RELEASE;
const SHOW_DEFAULT_EXPERTS = false;
exports.SHOW_DEFAULT_EXPERTS = SHOW_DEFAULT_EXPERTS;
// const SUPPORTED_LANGUAGES = ['en', 'fr', 'pt'];
const RESEND_TIMER = 45;
exports.RESEND_TIMER = RESEND_TIMER;
const PLAY_STORE_LINK = 'market://details?id=com.shalina.medspace';
exports.PLAY_STORE_LINK = PLAY_STORE_LINK;
const PLAY_STORE_WEB_LINK = 'https://play.google.com/store/apps/details?id=com.shalina.medspace';
exports.PLAY_STORE_WEB_LINK = PLAY_STORE_WEB_LINK;
const APP_STORE_LINK = 'itms-apps://apps.apple.com/in/app/shalina-medspace/id6483928968';
exports.APP_STORE_LINK = APP_STORE_LINK;
const APP_STORE_WEB_LINK = 'https://apps.apple.com/in/app/shalina-medspace/id6483928968';
exports.APP_STORE_WEB_LINK = APP_STORE_WEB_LINK;
const SHARE_MOB_BASE_URL = 'https://urlgeni.us/GTTr/?';
exports.SHARE_MOB_BASE_URL = SHARE_MOB_BASE_URL;
